import * as request from '@/utils/request'

export default {
  /**
   * @description 红人分成模块
   * @date 2022-08-01
   * @param {*} data
   * @returns
   */
  getArtistDivideList(data) {
    return request.post('/artist_divide/list', data)
  },
  /**
   * @description 获取文章分类列表
   * @date 2022-08-01
   * @returns
   */
  getArtistDivide(id) {
    let data = { id: id }
    return request.post('/artist_divide/info', data)
  },
  /**
   * @description 详情修改
   * @date 2022-08-01
   * @returns
   */
  updateArtistDivide(data) {
    return request.post('/artist_divide/save', data)
  },
  /**
   * 添加红人分成对应的订单明细
   * @param data
   * @returns {Promise}
   */
  addArtistOrder(data) {
    return request.post('/artist_order/add', data)
  },
  /**
   * 修改红人分成【打款凭据】
   * @param data
   * @returns {Promise}
   */
  updateArtistDivideVoucher(data) {
    return request.post('/artist_divide/update_voucher', data)
  },
  /**
   * 撤回凭据
   * @param data
   * @returns {Promise}
   */
  deleteArtistDivideVoucher(id) {
    return request.post('/artist_divide/delete_voucher', { id })
  },
  /**
   * 添加打款凭据附件（先调用上传接口，再用返回的文件信息绑定）
   * @param data { id: 分成记录ID, attachments: [{ id, full_path, original, size, ext }] }
   * @returns {Promise}
   */
  addArtistDivideAttachment(data) {
    return request.post('/artist_divide/add_attachment', data)
  },
  /**
   * 删除打款凭据附件
   * @param id 附件记录ID
   * @returns {Promise}
   */
  deleteArtistDivideAttachment(id) {
    return request.post('/artist_divide/delete_attachment', { id })
  },
  /**
   * @description 删除订单详情
   * @date 2022-08-01
   * @returns
   */
  delOrder(id) {
    let data = { order_ids: id }
    return request.post('/artist_order/delete', data)
  },
  /**
   * @description 项目组确认
   * @date 2022-08-01
   * @returns
   */
  artistAudit(data) {
    return request.post('/artist_divide/status', data)
  },
  /**
   * @description 导出订单明细
   * @date 2022-08-01
   * @returns
   */
  importOrder() {
    return request.get('/artist_order/import')
  },

  //
  /**
   * @description 钉钉发送消息
   * @date 2022-08-01
   * data {id: 红人分成记录ID, type: assistant|finance|payment, rec_user_ids: [userid]}
   * @returns
   */
  dingTalkNotifyartistDivide(data) {
    if (!data.id) {
      alert('分成记录ID必传')
      return false
    }
    if (['assistant', 'finance', 'payment'].indexOf(data.type) === -1) {
      alert('非法的消息类型')
      return false
    }

    if (!(data.rec_user_ids && data.rec_user_ids.length > 0)) {
      alert('接收人必传')
      return false
    }
    return request.post('/artist_divide/notify', { id: data.id, type: data.type, rec_user_ids: data.rec_user_ids })
  },
  /**
   *  批量发送【分成确认】通知
   * @param ids
   * @returns {Promise}
   */
  batchAssistantNotifyByIds(ids) {
    return request.post('/artist_divide/batch_notify', { ids: ids })
  },
  //
  /**
   * @description 钉钉发送历史查询
   * @date 2022-08-01
   * @returns
   */
  dingTalkNotifyHistory(vale) {
    let data = { info_id: vale }
    return request.post('/artist_divide/task_list', data)
  },
  //
  /**
   * @description 下载模板接口
   * @date 2022-08-01
   * @returns
   */
  downLoadTemplateNotify(data) {
    return request.postBlob('/artist_divide/export/template', data)
  },
  //
  /**
   * @description 批量审核通过
   * @date 2022-08-01
   * @returns
   */
  // batchartistAudit(data) {
  //   return request.post('/artist_divide/batch/check', data)
  // },
  // //
  // /**
  //  * @description 批量通知信息
  //  * @date 2022-08-01
  //  * @returns
  //  */
  // batchNotifysend(data) {
  //   return request.post('artist_divide/notify_group', data)
  // },

  //
  /**
   * @description 获取操作记录
   * @date 2022-08-01
   * @returns
   */
  getArtistDividelog(data) {
    return request.post('/artist_divide_log/list', data)
  },

  /**
   * @description 新增佣金分成
   * @date 2025-11-06
   * @param {*} data
   * @returns
   */
  addArtistDivide(data) {
    return request.post('/artist_divide/save', data)
  },
  /**
   * 同步
   * @param data
   * @returns {Promise}
   */
  syncArtistDivide(data) {
    return request.post('/artist_divide/sync', data)
  },
  /**
   * 删除红人分成[支持批量删除]
   * @param ids
   * @returns {Promise}
   */
  deleteArtistDivide(ids) {
    return request.post('/artist_divide/delete', { id: ids })
  },

  /**
   *
   * 红人分成查询（数据源自星广汇）
   * @param params
   * @returns {Promise}
   */
  getKolCommissionSplit(params = { year: '', month: '', artist_id: '' }) {

    return request.post('/artist_divide/kol_commission_split', params)
  },
  /**
   * 红人最新结算信息
   * @param artist_id
   * @returns {Promise}
   */
  getLastPayment(artist_id) {
    return request.post('/artist_divide/getLastPayment', { artist_id })
  },
  /**
   * 锁定红人分成
   * @param date_time
   * @returns {Promise}
   */
  lockArtistDivide(date_time) {
    return request.post('/artist_divide/lock', { date_time: date_time })
  },
  /**
   * 解锁红人分成
   * @param date_time
   * @returns {Promise}
   */
  unlockArtistDivide(date_time) {
    return request.post('/artist_divide/unlock', { date_time: date_time })
  },
}
